var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabSpecimenNot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C5.61667 20 4.4375 19.5125 3.4625 18.5375C2.4875 17.5625 2 16.3833 2 15V6C1.45 6 0.979167 5.80417 0.5875 5.4125C0.195833 5.02083 0 4.55 0 4V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H12C12.55 0 13.0208 0.195833 13.4125 0.5875C13.8042 0.979167 14 1.45 14 2V4C14 4.55 13.8042 5.02083 13.4125 5.4125C13.0208 5.80417 12.55 6 12 6V15C12 16.3833 11.5125 17.5625 10.5375 18.5375C9.5625 19.5125 8.38333 20 7 20ZM7 18C7.83333 18 8.54167 17.7083 9.125 17.125C9.70833 16.5417 10 15.8333 10 15H7V13H10V11H7V9H10V6H4V15C4 15.8333 4.29167 16.5417 4.875 17.125C5.45833 17.7083 6.16667 18 7 18Z",
    fill: "#B8170D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabSpecimenNot);
export default __webpack_public_path__ + "static/media/LabSpecimenNot.4d1547f8de50d290372f274b96f0ad19.svg";
export { ForwardRef as ReactComponent };